import { QueryClient } from 'react-query'
import { dehydrate } from 'react-query/hydration'
import Navigation from 'components/navigation'
import PlanetSection from 'home/planet-section'
import PricingSection from 'components/prices/pricing-section'
import { prefetchSubscriptionPlans } from 'querys/subscriptions'
import { prefetchStudentsPodium } from 'querys/student-projects'
import Testimonies from 'home/testimonies'
import ProjectStudentsHero from 'projects/students/student-projects-hero'
import Podium from 'projects/students/podium/podium'
import Footer from 'common/footer'
import Divider from 'common/divider'

function StudentsPodium() {
  return (
    <>
      <Navigation position="sticky" maxWidth="1336px" />
      <ProjectStudentsHero
        title="Nuestros mejores estudiantes"
        description="Conoce los portafolios de nuestros estudiantes destacados"
      />
      <Podium />
      <Testimonies />
      <PricingSection withUsersCount />
      <Divider color="transparent" marginVertical={64} />
      <PlanetSection />
      <Footer />
    </>
  )
}

export async function getStaticProps() {
  const queryClient = new QueryClient()
  await prefetchStudentsPodium({ queryClient, filter: 'monthly' })
  await prefetchSubscriptionPlans({ queryClient, product: 'ALL' })
  return {
    props: {
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
    },
    revalidate: 3600,
  }
}

export default StudentsPodium
